import React from 'react';
import { RailsBlock } from '@sls-react/typings/services/rails/tile';
import ChevronRight from '@sls-react/static/svg/ChevronRight';

interface Props extends React.HTMLAttributes<HTMLSelectElement> {
  block: RailsBlock;
  headerType?: 'h1' | 'h2' | 'h3';
  showCta?: boolean;
}

const BlockSection: React.FC<Props> = ({
  block,
  children,
  headerType: Header = 'h3',
  showCta = true,
  ...props
}) => (
  <section
    className="container my-4 md:my-8"
    {...props}
    id={`${block.id}-${block.layout}`}
  >
    {block.title && (
      <div className="flex items-baseline mb-2">
        <Header className="flex text-lg">{block.title}</Header>
        {showCta && block.destination && (
          <a
            href={block.destination}
            className="flex items-center ml-4 text-sm font-semibold text-primary-500"
          >
            {block.cta || 'See all'}{' '}
            <ChevronRight className="ml-2" height={12} />
          </a>
        )}
      </div>
    )}

    {children}
  </section>
);

export default BlockSection;
